// extracted by mini-css-extract-plugin
export default {"body-1":"gkt1KcV6XnBXO5YGBECC","body-2":"IFu8viOWuZjbPHLk_MhL","body-3":"JshiK2D3Dejlxnubk7lc","ant-typography":"CmsJqNdgZ5cvIS1dxzgM","tabButton":"HEtkTeFKlHmv48NazUEO"};